import React,{ Component } from 'react';
import Titulo from '../../components/Texto/Titulo';
import Pesquisa from '../../components/Inputs/Pesquisa';
import Paginacao from '../../components/Paginacao/Simples';
import { Link } from 'react-router-dom';

import { connect } from 'react-redux';
import * as actions from '../../actions/produtos';
import { getCategorias } from '../../actions/categorias';
import ProductTable from '../../components/Table/ProductTable';
import Loading from '../../components/Loading';
import { formatMoney } from '../../utils';

import { ReactComponent as IconStar } from '../../assets/saturnia-star.svg';
import {CSVLink} from "react-csv";
import { saveAs } from 'file-saver'; // For downloading the file

class Produtos extends Component {

    state = {
        pesquisa: "",
        atual: 0,
        limit: 30,
        ordem: "decrescente",
        refreshing: false,
        editingQuantity: null,
        filtrosAvancadosAbertos: false,
        filtroDestaque: "todos",
        filtroCategoria: "",
        filtroDisponibilidade: "todos",
        filtroEstoque: "todos"
    }

    filtrosListagem = () => {
        const { filtroDestaque, filtroCategoria, filtroDisponibilidade, filtroEstoque } = this.state;
        const f = {};
        if (filtroDestaque === "sim") f.destaque = "true";
        else if (filtroDestaque === "nao") f.destaque = "false";
        if (filtroCategoria) f.categoria = filtroCategoria;
        if (filtroDisponibilidade === "disponivel") f.disponibilidade = "true";
        else if (filtroDisponibilidade === "indisponivel") f.disponibilidade = "false";
        if (filtroEstoque === "com") f.estoque = "com";
        else if (filtroEstoque === "sem") f.estoque = "sem";
        return f;
    }

    getProdutos(props){
        const { atual, limit, pesquisa, ordem } = this.state;
        const filtros = this.filtrosListagem();

        if(!this.props.usuario) return null;

        if(pesquisa) this.props.getProdutosPesquisa(pesquisa, ordem, atual, limit, this.props.usuario.loja, filtros);
        else this.props.getProdutos(ordem, atual, limit, this.props.usuario.loja, filtros);
    }

    componentDidMount(){
		if(this.props.history.location.state && this.props.history.location.state.currentPage) return this.setState({ atual: this.props.history.location.state.currentPage });
        this.getProdutos(this.props);
        if (this.props.usuario) this.props.getCategorias(this.props.usuario.loja);
        this.props.limparProduto();
    }

    componentDidUpdate(prevProps){
        if(!prevProps.usuario && this.props.usuario) {
            this.props.getCategorias(this.props.usuario.loja);
            this.getProdutos(this.props);
        }
    }

    handleSubmitPesquisa(){
        this.setState({ atual: 0 }, () => this.getProdutos(this.props));
    }

    refreshList = () => {
        const { atual, limit, pesquisa, ordem } = this.state;

		this.setState({ refreshing: true })
		
        const filtros = this.filtrosListagem();
        if(pesquisa) this.props.getProdutosPesquisa(pesquisa, ordem, atual, limit, this.props.usuario.loja, filtros);
        else this.props.getProdutos(ordem, atual, limit, this.props.usuario.loja, filtros);

		const timer = setTimeout(() => {
			this.setState({ refreshing: false })
			clearTimeout(timer)
		}, 1800);
	}

    onChangePesquisa = (ev) => this.setState({ pesquisa: ev.target.value })

    changeNumeroAtual = (atual) => this.setState({ atual }, () => this.getProdutos(this.props));

    changeOrdem = (ev) => this.setState({ ordem: ev.target.value }, () => this.getProdutos(this.props));

    aplicarFiltrosAvancados = () => {
        this.setState({ atual: 0 }, () => this.getProdutos(this.props));
    };

    limparFiltrosAvancados = () => {
        this.setState({
            atual: 0,
            filtroDestaque: "todos",
            filtroCategoria: "",
            filtroDisponibilidade: "todos",
            filtroEstoque: "todos"
        }, () => this.getProdutos(this.props));
    };

    renderToggleAvailable(produto) {
        return (
            <div className={`toggle ${produto.disponibilidade ? 'true' : 'false'}`} onClick={() => this.props.updateProduto({ ...produto, disponibilidade: produto.disponibilidade ? 'indisponivel' : 'disponivel' }, produto._id, this.props.usuario.loja, () => this.refreshList())}>
                <div className={`toggle-selector ${produto.disponibilidade ? 'true' : 'false'}`}></div>
            </div>
        )
    }

    handleChangeHightlight = (produto) => {
        if(!produto.destaque && this.props.produtos?.docs?.filter(item => item.destaque).length >= 8) return window.alert("Quantidade máxima em destaque atingida! (8 produtos)")
        this.props.updateProduto({ ...produto, destaque: !produto.destaque, disponibilidade: produto?.disponibilidade ? 'disponivel' : 'indisponivel' }, produto._id, this.props.usuario.loja, () => this.refreshList())
    }

    renderHightlight(produto) {
        return <IconStar onClick={() => this.handleChangeHightlight(produto)}
        height={20} width={20} style={{ position: 'absolute', left: 15, top: 'calc(50% - 10px)', cursor: 'pointer', fill: produto?.destaque ? 'rgb(245 199 69)' : 'rgba(0,0,0,.3)' }} />
    }

    escapeXml = (value) => String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&apos;');

    mapProdutoMeta = (item) => {
        const hasPromo = item.promocao > 0 && item.promocao < item.preco;
        const price = Number(hasPromo ? item.promocao : item.preco).toFixed(2);
        return {
            id: item._id,
            title: item.titulo,
            description: item.descricao || item.titulo,
            availability: item.disponibilidade ? 'in stock' : 'out of stock',
            condition: 'new',
            price: `${price} BRL`,
            link: `https://loja.juliafloresrj.com.br/product/${encodeURIComponent(item.titulo)}?id=${item._id}`,
            image_link: `https://apiecommerce.juliafloresrj.com.br/public/images/${item.fotos?.[0] || ''}`,
            brand: 'Julia Flores'
        };
    };

    generateXML = () => {
        const { produtos } = this.props;
        const fbprod = (produtos?.docs || []).map(this.mapProdutoMeta);
        const ex = this.escapeXml;

        let xml = `<?xml version="1.0" encoding="UTF-8"?>
<rss xmlns:g="http://base.google.com/ns/1.0" version="2.0">
<channel>
<title>Julia Flores RJ</title>
<link>https://loja.juliafloresrj.com.br</link>
<description>Julia Flores RJ - A Floricultura mais bem avaliada do Rio de Janeiro.</description>\n`;

        fbprod.forEach(item => {
            xml += `<item>
<g:id>${ex(item.id)}</g:id>
<g:title>${ex(item.title)}</g:title>
<g:description>${ex(item.description)}</g:description>
<g:link>${ex(item.link)}</g:link>
<g:image_link>${ex(item.image_link)}</g:image_link>
<g:brand>${ex(item.brand)}</g:brand>
<g:condition>${item.condition}</g:condition>
<g:availability>${item.availability}</g:availability>
<g:price>${item.price}</g:price>
</item>\n`;
        });

        xml += `</channel>
</rss>`;

        const blob = new Blob([xml], { type: 'text/xml' });
        saveAs(blob, 'products.xml');
    };

    renderEditableQuantity = (produto) => {
        const { editingQuantity } = this.state;
        const isEditing = editingQuantity === produto._id;
        const quantidade = produto.quantidade || 0;
        
        // Determine CSS class based on quantity
        const getQuantityClass = (qty) => {
            if (qty < 2) return 'quantity-critical';
            if (qty < 5) return 'quantity-low';
            return 'quantity-good';
        };

        const handleQuantityEdit = (newQuantity) => {
            const parsedQuantity = parseInt(newQuantity);
            if (isNaN(parsedQuantity) || parsedQuantity < 0) {
                this.setState({ editingQuantity: null });
                return;
            }

            const updatedProduct = { 
                ...produto, 
                quantidade: parsedQuantity,
                nome: produto.titulo,
                disponibilidade: produto.disponibilidade ? 'disponivel' : 'indisponivel'
            };
            
            this.props.updateProduto(
                updatedProduct, 
                produto._id, 
                this.props.usuario.loja, 
                (error) => {
                    if (error) {
                        alert('Erro ao atualizar quantidade: ' + error.message);
                    }
                    this.setState({ editingQuantity: null });
                    this.refreshList();
                }
            );
        };

        const handleKeyPress = (e) => {
            if (e.key === 'Enter') {
                e.preventDefault();
                handleQuantityEdit(e.target.value);
            }
            if (e.key === 'Escape') {
                this.setState({ editingQuantity: null });
            }
        };

        const handleBlur = (e) => {
            handleQuantityEdit(e.target.value);
        };

        const baseStyle = {
            padding: '8px 12px',
            borderRadius: '4px',
            border: 'none',
            fontWeight: '600',
            textAlign: 'center',
            minWidth: '60px',
            fontSize: '14px'
        };

        if (isEditing) {
            return (
                <input
                    type="number"
                    min="0"
                    defaultValue={quantidade}
                    className={`quantity-input ${getQuantityClass(quantidade)}`}
                    style={{
                        ...baseStyle,
                        width: '80px',
                        outline: '2px solid #1976d2'
                    }}
                    onKeyDown={handleKeyPress}
                    onBlur={handleBlur}
                    autoFocus
                />
            );
        }

        return (
            <div
                className={`editable-quantity ${getQuantityClass(quantidade)}`}
                style={baseStyle}
                onClick={() => this.setState({ editingQuantity: produto._id })}
                title={`Clique para editar (Atual: ${quantidade}). Vermelho: <2, Laranja: <5, Verde: >=5`}
            >
                {quantidade}
            </div>
        );
    };

    render(){
        const { pesquisa } = this.state;
        const { produtos } = this.props;
        
        const dados = [];
        const fbprod = [];
        produtos?.docs?.forEach((item) => {
            dados?.push({
                "Ações": `/produto/${item._id}`,
                "Highlight": this.renderHightlight(item),
                "Produto": item.titulo,
                "Preço": formatMoney(item.preco),
                "Quantidade": this.renderEditableQuantity(item),
                "Disponibilidade": this.renderToggleAvailable(item)
            });
            fbprod?.push(this.mapProdutoMeta(item));
        });

        return produtos ? (
            <div className="Products">
                
                <div className="Page-Title">
                    <Titulo tipo="h1" titulo="Produtos"/>
                </div>

                <div className="produtosToolbar">
                    <div className="produtosToolbarTop">
                        <button
                            type="button"
                            className="produtosToolbarToggle"
                            onClick={() => this.setState((s) => ({ filtrosAvancadosAbertos: !s.filtrosAvancadosAbertos }))}
                            aria-expanded={this.state.filtrosAvancadosAbertos}
                            aria-label="Abrir ou fechar filtros avançados"
                            title="Filtros avançados"
                        >
                            <div className={`icon icon-toggle${this.state.filtrosAvancadosAbertos ? " active" : ""}`}>
                                <div></div>
                                <div></div>
                                <div></div>
                            </div>
                        </button>
                        <div className="produtosToolbarSearchWrap">
                            <Pesquisa
                                valor={pesquisa}
                                style={{ margin: 0 }}
                                placeholder="Pesquisar Produto"
                                onChange={(ev) => this.onChangePesquisa(ev)}
                                onClick={() => this.handleSubmitPesquisa()}
                            />
                        </div>
                        <Link to="/newproduct">
                            <div className="btnIcon plus" style={{ marginLeft: 0 }}></div>
                        </Link>
                    </div>
                    {this.state.filtrosAvancadosAbertos ? (
                        <div className="produtosFiltersDrawer">
                            <div className="entregasFiltersExtrasItems">
                                <label className="entregasFiltersPanel-field">
                                    <span>Destaque</span>
                                    <select
                                        value={this.state.filtroDestaque}
                                        onChange={(e) => this.setState({ filtroDestaque: e.target.value })}
                                    >
                                        <option value="todos">Todos</option>
                                        <option value="sim">Em destaque</option>
                                        <option value="nao">Sem destaque</option>
                                    </select>
                                </label>
                                <label className="entregasFiltersPanel-field">
                                    <span>Categoria</span>
                                    <select
                                        value={this.state.filtroCategoria}
                                        onChange={(e) => this.setState({ filtroCategoria: e.target.value })}
                                    >
                                        <option value="">Todas</option>
                                        {(this.props.categorias || [])
                                            .slice()
                                            .sort((a, b) => String(a.nome || "").localeCompare(String(b.nome || ""), "pt-BR"))
                                            .map((c) => (
                                                <option key={c._id} value={c._id}>{c.nome}</option>
                                            ))}
                                    </select>
                                </label>
                                <label className="entregasFiltersPanel-field">
                                    <span>Disponibilidade</span>
                                    <select
                                        value={this.state.filtroDisponibilidade}
                                        onChange={(e) => this.setState({ filtroDisponibilidade: e.target.value })}
                                    >
                                        <option value="todos">Todas</option>
                                        <option value="disponivel">Disponível para venda</option>
                                        <option value="indisponivel">Indisponível</option>
                                    </select>
                                </label>
                                <label className="entregasFiltersPanel-field">
                                    <span>Estoque</span>
                                    <select
                                        value={this.state.filtroEstoque}
                                        onChange={(e) => this.setState({ filtroEstoque: e.target.value })}
                                    >
                                        <option value="todos">Todos</option>
                                        <option value="com">Com estoque (quantidade &gt; 0)</option>
                                        <option value="sem">Sem estoque</option>
                                    </select>
                                </label>
                            </div>
                            <div className="produtosFiltersDrawer-footer">
                                <button type="button" className="entregasLimparFiltrosBtn" onClick={this.limparFiltrosAvancados}>
                                    Limpar filtros
                                </button>
                                <button type="button" className="produtosAplicarFiltrosBtn" onClick={this.aplicarFiltrosAvancados}>
                                    Aplicar filtros
                                </button>
                            </div>
                        </div>
                    ) : null}
                </div>

                <ProductTable cabecalho={["Highlight", "Produto", "Preço", "Quantidade", "Disponibilidade"]} currentPage={this.state.atual} gridClass="Products" refreshState={''} dados={dados} refreshList={() => this.refreshList()} />

                <div className="Products-footer">
                    <div className="Products-footer-actions">
                        <CSVLink data={fbprod} filename="produtos_meta.csv" target="_blank">
                            <div className="btnIcon fas fa-file-alt" title="Download CSV - META"></div>
                        </CSVLink>
                        <button type="button" title="XML facebook store" className="btnIcon" onClick={this.generateXML}>
                            <i className="fas fa-file-code" aria-hidden="true" />
                        </button>
                    </div>
                    <Paginacao
                        atual={this.state.atual}
                        total={this.props.produtos ? this.props.produtos.total : 0}
                        limite={this.state.limit}
                        onClick={(numeroAtual) => this.changeNumeroAtual(numeroAtual)}
                    />
                </div>
                
            </div>
        ) : <Loading />;
    }
}

const mapStateToProps = state => ({
    produtos: state.produto.produtos,
    usuario: state.auth.usuario,
    categorias: state.categoria.categorias
});

export default connect(mapStateToProps, { ...actions, getCategorias })(Produtos);